import { useCallback, useMemo, useState } from 'react';

type DirtyMap<T extends string> = Record<T, boolean>;

function useDirtySections<T extends string>(
    initialSections: DirtyMap<T>
): {
    dirtyMap: DirtyMap<T>;
    setDirty: (section: T, dirty: boolean) => void;
    isDirty: boolean;
} {
    const [dirtyMap, setDirtyMap] = useState<DirtyMap<T>>(initialSections);

    const setDirty = useCallback((section: T, dirty: boolean) => {
        setDirtyMap((prev) => ({ ...prev, [section]: dirty }));
    }, []);

    const isDirty = useMemo(() => Object.values(dirtyMap).some(Boolean), [dirtyMap]);

    return { dirtyMap, setDirty, isDirty };
}

export default useDirtySections;
